// @ts-nocheck
import React from "react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui";
import { BarChart } from "./BarChart";
import { ActivityIcon } from "./ActivityIcon";
import { fmtDate } from "./sellerDetail.utils";

export const OverviewTab = ({ d }) => (
  <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
    <Card>
      <CardHeader>
        <CardTitle className="text-base">Revenue Trend (6 Months)</CardTitle>
      </CardHeader>
      <CardContent>
        <BarChart data={d.revenueMonthly} valueKey="revenue" labelKey="month" />
      </CardContent>
    </Card>
    <Card>
      <CardHeader>
        <CardTitle className="text-base">Marketplace Distribution</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          {d.marketplaceRevenue.map((m) => (
            <div key={m.marketplace} className="flex items-center gap-3">
              <span className="text-sm text-slate-700 dark:text-slate-300 w-20">
                {m.marketplace}
              </span>
              <div className="flex-1 h-4 bg-slate-100 dark:bg-slate-800 rounded-full overflow-hidden">
                <div
                  className="h-full bg-indigo-500 rounded-full"
                  style={{ width: `${m.pct}%` }}
                />
              </div>
              <span className="text-xs font-medium text-slate-500 dark:text-slate-400 w-12 text-right">
                {m.pct}%
              </span>
              <span className="text-xs text-slate-700 dark:text-slate-300 w-16 text-right">
                ${(m.revenue / 1000).toFixed(1)}K
              </span>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
    <Card className="lg:col-span-2">
      <CardHeader>
        <CardTitle className="text-base">Recent Activity</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          {d.activityLog.slice(0, 5).map((a) => (
            <div key={a.id} className="flex items-center gap-3">
              <ActivityIcon icon={a.icon} />
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-slate-900 dark:text-slate-100">
                  {a.action}
                </p>
                <p className="text-xs text-slate-500 dark:text-slate-400 truncate">
                  {a.detail}
                </p>
              </div>
              <span className="text-xs text-slate-400 dark:text-slate-500 shrink-0">
                {fmtDate(a.timestamp)}
              </span>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  </div>
);
